import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { CanActivate } from "@angular/router";
import { AuthService } from "@services/auth.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService) { }

  canActivate(): Observable<boolean> {
    return this.auth.user$.pipe(
        map(user => {
          if (!user) {
            window.location.replace('/oidc/login');
            return false;
          }
          return true;
        })
      );
  }
}
